import MaskGroup1 from '../../assets/Mask Group 1.png';
import iPhone from '../../assets/iPhone-1.png';
import OcculusRift from '../../assets/Oculus-Rift-profile_grande.png';
import GoPro from '../../assets/50051823_540375.png';
import AppleMac from '../../assets/50061505_575246.png';
import NewsLetter from '../../assets/newsletter-img.png';
import SmartPhoneCard from '../../assets/smart-phone-card.png';
import LaptopLatestNews from '../../assets/Rectangle-1.png';
import PhoneLatestNews from '../../assets/Rectangle-2.png';
import HvTray from '../../assets/hv-tray.png';
import RainGauge from '../../assets/Netatmo_Rain_Gauge.png';
import BeatsSoloBrown1 from '../../assets/brown-1.png';
import BeatsSoloBrown2 from '../../assets/brown-2.png';
import BeatsSoloBrown3 from '../../assets/brown-3.png';
import BeatsSoloBrown4 from '../../assets/brown-4.png';
import BeatsSoloBrown5 from '../../assets/brown-5.png';
import BeatsSoloRed1 from '../../assets/red-1.png';
import BeatsSoloRed2 from '../../assets/red-2.png';
import BeatsSoloRed3 from '../../assets/red-3.png';
import BeatsSoloRed4 from '../../assets/red-4.png';
import BeatsSoloRed5 from '../../assets/red-5.png';
import BeatsSoloWhite1 from '../../assets/white-1.png';
import BeatsSoloWhite2 from '../../assets/white-2.png';
import BeatsSoloWhite3 from '../../assets/white-3.png';
import BeatsSoloWhite4 from '../../assets/white-4.png';
import BeatsSoloWhite5 from '../../assets/white-5.png';
import BeatsSoloBlack1 from '../../assets/black-1.png';
import BeatsSoloBlack2 from '../../assets/black-2.png';
import BeatsSoloBlack3 from '../../assets/black-3.png';
import BeatsSoloBlack4 from '../../assets/black-4.png';
import BeatsSoloBlack5 from '../../assets/black-5.png';
import BeatsSoloPink1 from '../../assets/pink-1.png';
import BeatsSoloPink2 from '../../assets/pink-2.png';
import BeatsSoloPink3 from '../../assets/pink-3.png';
import BeatsSoloPink4 from '../../assets/pink-4.png';
import BeatsSoloPink5 from '../../assets/pink-5.png';
import WesternUnionLogo from '../../assets/Western-union.png';
import PaypalLogo from '../../assets/Paypal.png';
import VisaLogo from '../../assets/visa.jpg';
import MasterCardLogo from '../../assets/mastercard.png';
import AppleLogo from '../../assets/login_signup/apple-64.png';
import FacebookLogo from '../../assets/login_signup/fb-64.png';
import Background from '../../assets/login_signup/cover-img.jpg';
import Phillips from '../../assets/phillips.png';

export default class Images{
    Phillips(){
        return Phillips;
    }
    Background() {
        return Background;
    }
    BeatsSoloBrown1(){
        return BeatsSoloBrown1;
    }
    BeatsSoloBrown2(){
        return BeatsSoloBrown2;
    }
    BeatsSoloBrown3(){
        return BeatsSoloBrown3;
    }
    BeatsSoloBrown4(){
        return BeatsSoloBrown4;
    }
    BeatsSoloBrown5(){
        return BeatsSoloBrown5;
    }
    BeatsSoloRed1(){
        return BeatsSoloRed1;
    }
    BeatsSoloRed2(){
        return BeatsSoloRed2;
    }
    BeatsSoloRed3(){
        return BeatsSoloRed3;
    }
    BeatsSoloRed4(){
        return BeatsSoloRed4;
    }
    BeatsSoloRed5(){
        return BeatsSoloRed5;
    }
    BeatsSoloWhite1() {
        return BeatsSoloWhite1;
    }
    BeatsSoloWhite2(){
        return BeatsSoloWhite2;
    }
    BeatsSoloWhite3(){
        return BeatsSoloWhite3;
    }
    BeatsSoloWhite4(){
        return BeatsSoloWhite4;
    }
    BeatsSoloWhite5(){
        return BeatsSoloWhite5;
    }
    BeatsSoloPink5(){
        return BeatsSoloPink5;
    }
    BeatsSoloPink4(){
        return BeatsSoloPink4;
    }
    BeatsSoloPink3(){
        return BeatsSoloPink3;
    }
    BeatsSoloPink2(){
        return BeatsSoloPink2;
    }
    BeatsSoloPink1(){
        return BeatsSoloPink1;
    }
    FacebookLogo(){
        return FacebookLogo;
    }
    AppleLogo(){
        return AppleLogo;
    }
    WesternUnionLogo(){
        return WesternUnionLogo;
    }
    MasterCardLogo(){
        return MasterCardLogo;
    }
    VisaLogo(){
        return VisaLogo;
    }
    PaypalLogo(){
        return PaypalLogo;
    }
    BeatsSoloBlack5(){
        return BeatsSoloBlack5;
    }
    BeatsSoloBlack4(){
        return BeatsSoloBlack4;
    }
    BeatsSoloBlack3(){
        return BeatsSoloBlack3;
    }
    BeatsSoloBlack2(){
        return BeatsSoloBlack2;
    }
    BeatsSoloBlack1(){
        return BeatsSoloBlack1;
    }
    MaskGroup1() {
        return MaskGroup1;
    }
    iPhone(){
        return iPhone;
    }
    OcculusRift(){
        return OcculusRift;
    }
    GoPro(){
        return GoPro;
    }
    AppleMac(){
        return AppleMac;
    }
    NewsLetter(){
        return NewsLetter;
    }
    SmartPhoneCard(){
        return SmartPhoneCard;
    }
    LaptopLatestNews(){
        return LaptopLatestNews;
    }
    PhoneLatestNews(){
        return PhoneLatestNews;
    }
    HvTray(){
        return HvTray;
    }
    RainGauge(){
        return RainGauge;
    }
}

